const matchEscapable = /[-/\\^$*+?.()|[\]{}]/g;

export default function escapeRegexp(string) {
  return typeof string === 'string'
    ? string.replace(matchEscapable, '\\$&'): string;
}
